import type { Catalog } from "../en";
import { webappPortalOrders } from "./webapp-portal-orders";
import { webappPortalAfterSales } from "./webapp-portal-aftersales";

/** Web app portal — Filipino (Taglish where natural; follows the widget's My tickets words in `copy-fil.ts`). */
export const webappPortal: Catalog["webapp"]["portal"] = {
  orders: webappPortalOrders,
  afterSales: webappPortalAfterSales,
  pageTitle: "Support portal ng {{org}}",
  auth: { footer: "Ang mga ticket mo ay para lang sa iyo at sa team na tumutulong sa iyo." },
  nav: { label: "Portal", tickets: "Aking mga ticket", ticketsShort: "Mga ticket", chat: "Makipag-chat sa assistant", chatShort: "Chat" },
  user: { menu: "Menu ng account", fallbackName: "Naka-sign in", member: "Miyembro", orgAdmin: "Admin ng organisasyon" },
  data: {
    menu: "Iyong data",
    back: "Bumalik sa aking mga ticket",
    title: "Iyong data",
    intro: "Alinsunod sa Data Privacy Act (RA 10173), dito mo makukuha ang kopya ng hawak ng {{org}} tungkol sa iyo, o hilingin na burahin ito.",
    consentTitle: "Iyong pahintulot",
    consentGiven: "Tinanggap mo ang privacy notice {{version}} noong {{date}}.",
    consentNone: "Wala pang naitalang pahintulot mo.",
    consentUnknown: "Makikita ang naitalang pahintulot mo kapag naihanda na ang data mo sa ibaba.",
    exportTitle: "Kumuha ng kopya ng data mo",
    exportBody: "Maghahanda kami ng isang file na may mga detalye mo, pahintulot mo, ang mga pampublikong mensahe ng mga ticket mo at, kung mayroon, ang mga order, quote, kagamitan, pagbisita at pagbabalik mo. Hindi kasama ang mga internal na tala ng team.",
    exportButton: "Ihanda at i-download ang data ko",
    exportAgain: "I-download muli",
    exportPreparing: "Inihahanda ang data mo",
    exportReady: "Handa na ang data mo at nai-save sa device mo. Mga ticket na kasama: {{count}}.",
    exportSections: "Kasama rin sa file mo",
    exportSection: { orders: "Mga order", quotes: "Mga quotation", carts: "Mga bukas na cart", assets: "Mga kagamitang inulat mo", visits: "Mga pagbisita ng serbisyo", installations: "Mga pagtanggap ng instalasyon", rmas: "Mga pagbabalik" },
    exportFailed: "Hindi namin naihanda ang data mo. Pakisubukan muli.",
    downloaded: "Na-download ang data mo",
    rateLimited: "Ilang beses mo na itong sinubukan. Maghintay muna bago subukan ulit.",
    eraseTitle: "Burahin ang data ko",
    eraseBody: "Hilingin sa {{org}} na burahin ang mga personal na detalye mo. Mananatiling walang pangalan mo ang mga ticket at order, pero hindi mabubura ang mga ticket, order at iba pang talaan mismo.",
    eraseButton: "Burahin ang data ko",
    eraseFailed: "Hindi namin nabura ang data mo. Pakisubukan muli.",
    confirmTitle: "Buburahin ang data mo?",
    confirmIntro: "Permanenteng buburahin nito, para sa {{org}}:",
    confirmContact: "ang pangalan, email, numero ng telepono at trabaho mo",
    confirmWords: "ang mga personal na detalye sa isinulat mo sa mga ticket, at ang mga file na ipinadala mo",
    confirmRecords: "ang mga address ng delivery, pangalan sa sign-off at lagda mo sa mga order, quotation, pagbisita, pagtanggap at pagbabalik, at ang mga bukas mong cart",
    confirmKeep: "Mananatili sa {{org}} ang mga ticket, order, pagbisita at iba pang talaan mismo, nang walang pangalan mo. Hindi na ito mababawi at masa-sign out ka.",
    confirmCancel: "Panatilihin ang data ko",
    confirmErase: "Burahin ang data ko",
    erasedTitle: "Nabura ang data mo",
    erasedBody: "Naalis na ang mga personal na detalye mo. Masa-sign out ka na sa portal.",
    erasedDone: "Mag-sign out",
  },
  index: { title: "Pumili ng ticket", hint: "Pumili mula sa listahan para basahin at sagutin ito, o mag-report ng bagong problema." },
  list: {
    title: "Aking mga ticket",
    new: "Bagong ticket",
    search: "Maghanap ayon sa numero o pamagat",
    clearSearch: "Burahin ang hanap",
    noMatches: "Walang tugma",
    noMatchesHint: "Subukan ang ibang numero o salita.",
    emptyTitle: "Wala ka pang ticket",
    emptyHint: "Kapag nag-report ka ng problema, masusubaybayan mo ito rito.",
    emptyCta: "Mag-report ng problema",
    closedEmptyTitle: "Walang saradong ticket",
    closedEmptyHint: "Dito itinatago ang mga ticket na naayos at sarado na.",
    orgEmptyTitle: "Wala pang ticket mula sa organisasyon mo",
    orgLocked: "Lalabas dito ang mga ticket ng kasamahan mo kapag ibinahagi nila, o kapag pinayagan ka ng admin ng organisasyon mo.",
    listLabel: "Mga ticket",
    tabsLabel: "Katayuan ng ticket",
    scopeLabel: "Kaninong mga ticket",
    scope: { mine: "Akin", organisation: "Aming organisasyon" },
    tab: { open: "Bukas", closed: "Sarado" },
    showMore: "Magpakita pa",
    unread: "Hindi pa nababasang update",
    actionNeeded: "Kailangan ng aksyon",
  },
  detail: {
    back: "Bumalik sa aking mga ticket",
    created: "Ginawa noong {{when}}",
    assignee: "Inaasikaso ni {{name}}",
    followUpOf: "Follow-up ng {{number}}",
    told: "Mga detalyeng ibinigay mo",
    description: "Paglalarawan",
    timeline: "Timeline",
    files: "Mga attachment",
    liveOn: "Live",
    polling: "Nag-a-update",
    notFoundTitle: "Hindi namin mahanap ang ticket na iyon",
    notFoundBody: "Maaaring sa iba ito, o mali ang numero. Tingnan ang e-mail kung saan ito galing.",
  },
  priority: { low: "Mababa", normal: "Normal", high: "Mataas", urgent: "Madalian" },
  thread: {
    label: "Usapan sa ticket",
    empty: "Wala pang mensahe. I-a-update ka namin dito.",
    you: "Ikaw",
    colleague: "{{name}} (kasamahan)",
    team: "Aming team",
    assistant: "Assistant",
    removed: "Inalis ang mensaheng ito.",
    openFile: "Buksan ang {{name}}",
    fileFailed: "Hindi namin mabuksan ang file na iyon. Subukan ulit.",
  },
  composer: {
    label: "Sumagot",
    placeholder: "Isulat ang mensahe mo…",
    send: "Ipadala",
    sent: "Naipadala ang sagot mo",
    writeFirst: "Isulat muna ang mensahe mo bago ipadala.",
    waitUpload: "Hintayin munang matapos ang upload bago magpadala.",
    closedNote: "Sarado na ang ticket na ito. Kung kailangan mo pa ng tulong, gumawa ng bagong ticket.",
    cannotReply: "Mababasa mo ang ticket na ito, pero ang nagbukas lang nito ang makakasagot.",
    followUp: "Nagbukas kami ng {{number}} para sa mensahe mo, dahil sarado na ang ticket na ito.",
  },
  files: {
    attach: "Ikabit",
    remove: "Alisin ang {{name}}",
    uploading: "Ina-upload…",
    scanning: "Sine-scan…",
    clean: "Na-scan, malinis",
    blocked: "Hindi namin matanggap ang file na ito.",
    failed: "Hindi na-upload. Subukan ulit.",
    type: "Hindi tinatanggap ang ganitong uri ng file.",
    size: "Masyadong malaki ang file na iyon.",
    count: "Hanggang {{n}} file sa isang mensahe.",
  },
  resolved: {
    title: "Naayos na — pakikumpirma",
    closedTitle: "Sarado na ang ticket na ito",
    confirm: "Kumpirmahing naayos na",
    confirmed: "Kinumpirma. Sarado na ang ticket na ito.",
    stillProblem: "May problema pa rin",
    stillHint: "Sabihin kung ano pa ang mali sa {{number}} at bubuksan namin itong muli.",
    stillLabel: "Ano pa ang problema?",
    stillShort: "Sabihin kung ano pa ang problema (hindi bababa sa {{n}} character).",
    stillSend: "Buksan muli ang ticket",
    reopened: "Binuksan muli ang ticket.",
  },
  csat: {
    question: "Gaano ka nasiyahan sa pag-asikaso namin sa {{number}}?",
    stars: "Rating",
    starLabel: "{{n}} sa 5 bituin",
    why: "Ano ang nangyari?",
    comment: "Komento (opsyonal)",
    send: "Ipadala ang rating",
    thanks: "Salamat! Naitala ang {{n}}-bituin na rating mo.",
    rated: "Nag-rate ka ng {{n}} bituin",
  },
  csatPage: {
    title: "Kumusta ang serbisyo ng {{org}}?",
    score: "{{n}} sa 5 bituin",
    send: "Ipadala ang rating ko",
    note: "Mapupunta ang rating mo sa team na umasikaso ng ticket mo.",
    thanksTitle: "Salamat sa rating mo",
    thanksBody: "Naitala ang {{n}}-bituin na rating mo para sa {{number}}.",
    replaced: "Pinalitan nito ang naunang rating mo para sa ticket na ito.",
    usedTitle: "Nagamit na ang rating link na ito",
    usedBody: "Salamat, naitala na ang sagot mo. Isang beses lang gumagana ang link.",
    expiredTitle: "Nag-expire na ang rating link na ito",
    expiredBody: "May takdang oras ang mga rating link. Puwede mo pa ring i-rate ang ticket mula sa pahina ng mga ticket mo.",
    invalidTitle: "Hindi wasto ang rating link na ito",
    invalidBody: "Maaaring naputol ito nang kopyahin. Buksan ulit ang link mula sa e-mail.",
    unavailableTitle: "Hindi available dito ang pag-rate",
    unavailableBody: "Hindi tumatanggap ng rating ang service desk na ito sa ngayon.",
    viewTickets: "Pumunta sa aking mga ticket",
  },
  actions: {
    more: "Iba pang aksyon",
    downloadPdf: "I-download bilang PDF",
    downloadFailed: "Hindi na-download ang PDF. Pakisubukan ulit.",
    receiptsNote: "Nakikita ng team kapag binuksan mo ang kanilang mga sagot.",
    share: "Ibahagi sa organisasyon ko",
    unshare: "Ihinto ang pagbabahagi sa organisasyon ko",
    shareOn: "Nakabahagi sa organisasyon mo",
    shareOff: "Hindi nakabahagi sa organisasyon mo",
    addColleague: "Magdagdag ng kasamahan",
    colleagueHint: "Masusubaybayan at masasagot ng idaragdag mong kasamahan ang {{number}}.",
    colleagueLabel: "Kasamahan",
    colleaguePlaceholder: "Pumili ng kasamahan",
    colleagueRequired: "Pumili muna ng kasamahan.",
    colleagueAdd: "Idagdag ang kasamahan",
    colleagueAdded: "Naidagdag ang kasamahan",
    withdraw: "Bawiin ang ticket na ito",
    withdrawHint: "Bawiin ang {{number}} kung hindi mo na kailangan ng tulong. Sasabihan ang team at isasara ito.",
    withdrawReason: "Bakit mo binabawi? (opsyonal)",
    withdrawConfirm: "Bawiin ang ticket",
    withdrawn: "Binawi ang ticket",
  },
  emailAction: {
    confirmTitle: "Kumpirmahing naayos na ito",
    confirmBody: "Kung gumagana na ang lahat, kumpirmahin ito at isasara namin ang ticket.",
    stillTitle: "Sabihin kung ano pa ang problema",
    stillBody: "Bubuksan namin muli ang ticket at ipagpapatuloy ito ng team.",
    withdrawTitle: "Bawiin ang ticket na ito",
    withdrawBody: "Kung hindi mo na kailangan ng tulong, bawiin ito at ihihinto ng team ang pag-asikaso.",
    unavailableTitle: "Hindi na mababago ang {{number}} sa ganitong paraan",
    unavailableBody: "Ngayon ay “{{status}}” na ito. Buksan ang ticket para makita ang puwede mong gawin.",
    view: "Buksan ang ticket",
    notNow: "Huwag muna",
  },
  errors: {
    title: "Hindi namin ito ma-load",
    generic: "Nagkaproblema sa aming panig. Pakisubukang muli.",
    offline: "Mukhang offline ka. Tingnan ang koneksyon mo at subukan ulit.",
    limited: "Masyadong maraming request ngayon. Maghintay sandali at subukan ulit.",
    action: "Hindi ito natuloy. Pakisubukan ulit.",
    unavailableTitle: "Hindi available dito ang mga ticket sa ngayon",
    unavailableBody: "Hindi pa bukas para sa mga ticket ang service desk na ito. Gamitin ang chat para makausap ang team.",
  },
  new: {
    title: "Bagong ticket",
    back: "Bumalik",
    step: "Hakbang {{a}} ng {{b}}",
    groupTitle: "Ano ang kailangan mo?",
    groupHint: "Pumili ng grupo, saka ng uri.",
    typeCount: "Uri: {{n}}",
    chooseType: "Pumili ng uri",
    otherGroup: "Iba pa",
    type: "Uri",
    fieldTitle: "Pamagat",
    fieldDescription: "Paglalarawan",
    photos: "Mga larawan o video",
    optional: "opsyonal",
    required: "kailangan",
    chooseOne: "Pumili ng isa",
    yes: "Oo",
    no: "Hindi",
    continue: "Magpatuloy",
    review: "Suriin",
    filesCount: "Mga attachment: {{n}}",
    backToEdit: "Bumalik sa pag-edit",
    submit: "Isumite ang ticket",
    fixFields: "Ayusin ang mga naka-highlight na field.",
    created: "Nagawa na ang ticket {{number}}",
    createdHint: "Mag-e-e-mail kami kapag may update. Masusubaybayan mo rin ito rito.",
    view: "Tingnan ang ticket",
    loadFailed: "Hindi namin ma-load ang mga uri ng ticket",
    unavailableTitle: "Hindi pa available dito ang mga bagong ticket",
    unavailableBody: "Ilarawan ang problema sa chat at magbubukas kami ng ticket para sa iyo.",
    describeInChat: "Ilarawan na lang sa chat",
    issue: {
      required: "Kailangan ito.",
      tooLong: "Masyadong mahaba ito.",
      email: "Maglagay ng wastong e-mail.",
      number: "Maglagay ng numero.",
      integer: "Maglagay ng buong numero.",
      date: "Maglagay ng wastong petsa.",
      option: "Pumili ng isa sa mga opsyon.",
      title: "Gawing {{max}} character o mas kaunti ang pamagat.",
      description: "Gawing {{max}} character o mas kaunti ang paglalarawan.",
    },
  },
  handoff: {
    working: "Binubuksan ang mga ticket mo",
    failedTitle: "Hindi namin mabuksan ang mga ticket mo",
    failedBody: "Isang beses at sandali lang gumagana ang link mula sa chat. Mag-sign in gamit ang e-mail mo para magpatuloy.",
    failedToast: "Hindi magamit ang link na iyon. Mag-sign in para magpatuloy.",
    signIn: "Mag-sign in",
  },
  signIn: {
    requestTitle: "Mag-sign in para makita ang mga ticket mo",
    requestBody: "Ilagay ang e-mail na kilala ng {{org}}. Magpapadala kami ng link, walang password na kailangan.",
    emailLabel: "E-mail",
    emailPlaceholder: "ikaw@kumpanya.com",
    emailInvalid: "Maglagay ng wastong e-mail.",
    send: "I-e-mail sa akin ang sign-in link",
    noPassword: "Walang password. Huwag ibahagi ang link na ito.",
    requestLimited: "Masyadong maraming subok. Maghintay sandali bago humingi ulit.",
    requestFailed: "Hindi namin naipadala ang link. Pakisubukan ulit.",
    requestUnavailable: "Hindi available dito ang pag-sign in gamit ang e-mail sa ngayon.",
    captcha: "Hintayin munang matapos ang security check, saka subukan ulit.",
    sentTitle: "Tingnan ang inbox mo",
    sentBody: "Kung nasa talaan namin ang address na ito, papunta na ang sign-in link sa {{email}}. Isang beses lang itong gumagana at mag-e-expire sa {{minutes}} minuto.",
    sentDevice: "Buksan ang link sa device na ito: gumagana lang ito sa browser na pinanggalingan ng hiling.",
    resend: "Ipadala ulit ang link",
    resendIn: "Ipadala ulit sa {{time}}",
    resentToast: "Nagpadala ng bagong sign-in link",
    change: "Gumamit ng ibang e-mail",
    endedIdle: "Na-sign out ka matapos ang 30 minutong walang aktibidad. Mag-sign in ulit para magpatuloy.",
    endedAbsolute: "Para sa seguridad mo, natatapos ang session pagkaraan ng 12 oras. Mag-sign in ulit para magpatuloy.",
    endedExpired: "Natapos na ang session mo. Mag-sign in ulit para magpatuloy.",
    endedSignedOut: "Naka-sign out ka na.",
    linkTitle: "Mag-sign in sa {{org}}",
    linkBody: "Magpatuloy sa mga ticket mo. Isang beses lang gumagana ang link na ito at mag-e-expire sa {{minutes}} minuto.",
    deviceNote: "Nakatali ito sa device na ito: {{device}}.",
    wasSentTo: "Ipinadala ang link sa {{email}}.",
    deviceBoth: "{{browser}} sa {{system}}",
    continue: "Magpatuloy",
    sendNew: "Magpadala ng bagong link",
    usedTitle: "Nagamit na ang link na ito",
    expiredTitle: "Nag-expire na ang link",
    usedBody: "Isang beses lang gumagana ang mga link at {{minutes}} minuto lang. Puwede kaming magpadala ng bago.",
    mismatchTitle: "Sa ibang device hiningi ang link na ito",
    mismatchBody: "Para sa seguridad mo, gumagana lang ang link sa browser na pinanggalingan ng hiling. Magpadala ng bagong link mula sa device na ito.",
    invalidTitle: "Hindi wasto ang link na ito",
    invalidBody: "Maaaring naputol ito nang kopyahin. Magpadala ng bagong link.",
    unavailableTitle: "Hindi available dito ang pag-sign in",
    unavailableBody: "Hindi tumatanggap ng sign-in ang {{org}} sa ngayon. Subukan ulit mamaya.",
    limitedTitle: "Masyadong maraming subok",
    limitedBody: "Maghintay sandali at subukan ulit.",
    offlineTitle: "Mukhang offline ka",
    offlineBody: "Tingnan ang koneksyon mo at subukan ulit. Hindi pa nagagamit ang link.",
    failedTitle: "Hindi ka namin ma-sign in",
    failedBody: "Nagkaproblema sa aming panig. Subukan ulit, o magpadala ng bagong link.",
  },
};
